import { withSvgIcon } from './withSvgIcon';

export const NavBarStatus = withSvgIcon(
  <>
    <path
      d="M12 3L20 7V17L12 21L4 17V7L12 3Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path d="M12 13.5V10.4999" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M15 15C15 15 16 13.2349 16 12C16 10.7651 15 9 15 9"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M8.99998 15C8.99998 15 8 13.2349 8 12C8 10.7651 8.99998 9 8.99998 9"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
